export default "__VITE_ASSET__CtTDHZ1B__"